export const agGridLocaleEN = {
    of: "of",
    to: "to",
    page: "Page",
};
